/** Formatage des nombres et durées pour le HUD (fr-FR). */
const nf0 = new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 0 });
const nf1 = new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 1, minimumFractionDigits: 1 });
const nf2 = new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 2, minimumFractionDigits: 2 });

// Intl sépare les milliers par une espace fine (U+202F), presque invisible dans la police du HUD :
// on la remplace par une espace insécable normale (283 700 et non 283700).
const fx = (s: string): string => s.replace(/\u202f/g, '\u00a0');

export const n0 = (v: number): string => fx(nf0.format(v));
export const n1 = (v: number): string => fx(nf1.format(v));
export const n2 = (v: number): string => fx(nf2.format(v));

/** Montant en euros : 1 234 567 € ou 1,2 M€. */
export function euros(v: number, compact = false): string {
  if (compact && Math.abs(v) >= 1_000_000) return `${n1(v / 1_000_000)} M€`;
  if (compact && Math.abs(v) >= 10_000) return `${n0(v / 1000)} k€`;
  return `${n0(v)} €`;
}

/** Durée en secondes de simulation vers « 3 min » ou « 45 s ». */
export function duration(sec: number): string {
  if (sec >= 3600) return '> 1 h';
  if (sec >= 60) return `${n0(sec / 60)} min`;
  return `${n0(sec)} s`;
}
